import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  // Team members data
  // const teamMembers = [
  //   {
  //     id: 1,
  //     name: 'Allan Oluoch',
  //     position: 'Founder & CEO',
  //     image: '/images/team/allan-oluoch.jpg'
  //   },
  //   {
  //     id: 2,
  //     name: 'Migwi Kiragu',
  //     position: 'Partnerships Lead',
  //     image: '/images/team/migwi-kiragu.jpg'
  //   },
  //   {
  //     id: 3,
  //     name: 'Linet Atieno',
  //     position: 'Product Manager',
  //     image: '/images/team/linet-atieno.jpg'
  //   },
  //   {
  //     id: 4,
  //     name: 'Ted Amigo',
  //     position: 'Software Engineer',
  //     image: '/images/team/ted-amigo.jpg'
  //   }
  // ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-content">
          <h1>Smart Solutions. Real Business Impact.</h1>
          <p className="hero-description">
            We are a leading provider of Mobile Communication Solutions in Kenya, combining business insights with cutting-edge technology to create smart, practical, and scalable solutions that connect businesses with customers and drive long-term impact.
          </p>
        </div>
        <div className="hero-background">
          <div className="circle-navy"></div>
          <div className="circle-light-blue"></div>
          <div className="circle-peach"></div>
        </div>
      </section>

      {/* Hero Image */}
      <div className="hero-image-container">
        <img src="/images/about.jpg" alt="Team silhouette against natural landscape" className="hero-image" />
      </div>

      {/* Our Story Section */}
      <section className="our-story">
        <h2>Our Story</h2>
        
        <div className="story-container">
          <div className="story-logo">
            <img src="/images/company-logo.jpg" alt="Peak Mobile Logo" />
          </div>
          
          <div className="story-content">
            <p className="story-intro">
              At Peak Mobile, we don't just build products, we create impactful, customer-centric solutions.Founded in 2022,
              Peak Mobile was born out of the desire to revolutionize how businesses connect with their customers. For the first two years, we focused on iterating our platform, business model, and services to stay aligned with our customers' evolving needs.
            </p>
            
            <p className="story-mission">
              Today, Peak Mobile is a trusted partner for businesses looking to drive customer engagement, boost acquisition, and build lasting loyalty.
            </p>
          </div>
        </div>
      </section>

      {/* Meet the Team Section */}
      {/* <section className="team-section">
        <h2>Meet the Team</h2>
        
        <div className="team-grid">
          {teamMembers.map(member => (
            <div className="team-card" key={member.id}>
              <div className="member-image">
                <img src={member.image} alt={member.name} />
              </div>
              <h3 className="member-name">{member.name}</h3>
              <p className="member-position">{member.position}</p>
            </div>
          ))}
        </div>
      </section> */}

      {/* What We Do Section */}
      <section className="what-we-do">
        <h2>What Peak Mobile Can Do For You</h2>
        
        <div className="services-grid-about">
          <div className="service-card-about">
            <div className="service-icon-about">
              <img src="/images/acquire.svg" alt="Acquire icon" />
            </div>
            <h3>Acquire</h3>
            <p>
              We provide you with powerful tools to run acquisition campaigns that not only convert but also deliver measurable ROI.
            </p>
          </div>
          
          <div className="service-card-about">
            <div className="service-icon-about">
              <img src="/images/engage.svg" alt="Engage icon" />
            </div>
            <h3>Engage</h3>
            <p>
              Boost user engagement with our fun, interactive games designed to captivate and excite your audience.
            </p>
          </div>
          
          <div className="service-card-about">
            <div className="service-icon-about">
              <img src="/images/retain.svg" alt="Retain icon" />
            </div>
            <h3>Retain</h3>
            <p>
              Foster long-term loyalty with Rewards that connect you to your customers during their special moments—like birthdays or anniversaries.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;